import classnames from 'classnames'
import _ from 'lodash'
import Link from 'next/link'
import { useRouter } from 'next/router'
import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { DropdownItem, DropdownMenu, UncontrolledDropdown } from 'reactstrap'
import { Badge } from 'reactstrap'

import { useAuth } from '../../providers/AuthProvider'
import { useFirebase } from '../../providers/FirebaseProvider'
import { useWorkspace } from '../../providers/WorkspaceProvider'

const AdminToolDropdown = ({ toggle }) => {
  const { t } = useTranslation()
  const {
    currentWorkspace,
    setCurrentWorkspace,
    workspaces,
    isWorkspaceOwner,
    workspaceLimit
  } = useWorkspace()
  const { firebase } = useFirebase()
  const { userData, currentPlan } = useAuth()
  const router = useRouter()

  const largeList = workspaces.length > 14

  const onDropdownOutsideClick = (e) => {
    e.stopPropagation()
    e.preventDefault()

    if (e.target.classList.contains('dropdown-item')) {
      toggle()
    }
  }

  const goTo = (url) => {
    toggle()
    router.push(url)
  }

  return (
    <UncontrolledDropdown
      className={`workspace-dropdown ${largeList && 'large-list'}`}
      direction="left"
    >
      <div className="text-nowrap d-flex align-items-center">
        <i className="mdi mdi-chevron-left"></i>
        <div className="ms-2">
          <span>Admin tools</span>
        </div>
      </div>
      <DropdownMenu onClick={onDropdownOutsideClick}>
        <DropdownItem header>
          <span>{t('Tools')}</span>
        </DropdownItem>
        <DropdownItem tag="div" key="impersonate">
          <Link href="/impersonate" legacyBehavior>
            <a>
              <i className="mdi mdi-account-circle font-size-16 align-middle ms-1" />{' '}
              {t('Impersonate')}
            </a>
          </Link>
        </DropdownItem>
        <DropdownItem tag="div" key="copy-display">
          <Link href="/copyDisplay" legacyBehavior>
            <a>
              <i className="mdi mdi-content-copy font-size-16 align-middle ms-1" />{' '}
              {t('Copy display')}
            </a>
          </Link>
        </DropdownItem>
        <DropdownItem tag="div" key="copy-test">
          <Link href="/copyTest" legacyBehavior>
            <a>
              <i className="mdi mdi-content-copy font-size-16 align-middle ms-1" />{' '}
              {t('Copy AB test')}
            </a>
          </Link>
        </DropdownItem>
        <DropdownItem tag="div" key="template-creator">
          <Link href="/template-creator" legacyBehavior>
            <a>
              <i className="mdi mdi-pencil font-size-16 align-middle ms-1" />{' '}
              {t('Template creator')}
            </a>
          </Link>
        </DropdownItem>
        <DropdownItem tag="div" key="template-manager">
          <Link href="/template-manager" legacyBehavior>
            <a>
              <i className="mdi mdi-clipboard-edit font-size-16 align-middle ms-1" />{' '}
              {t('Template manager')}
            </a>
          </Link>
        </DropdownItem>
      </DropdownMenu>
      <style jsx>{`
        .buttons {
          color: #5c3dc2 !important;
        }

        :global(.workspace-dropdown.large-list .dropdown-menu) {
          max-height: 500px;
          overflow: auto;
          padding-bottom: 0;
        }
      `}</style>
    </UncontrolledDropdown>
  )
}

export default AdminToolDropdown
